const HorizontalSidebarData = [
  {
    title: "Dashboard",
    href: "/Dashboards/AdminDashboard",
    id: 1,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-house"></i>,
  },

  {
    title: "User Management",
    href: "#",
    id: 2,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-person"></i>,
    collapisble: true,
    children: [
      {
        title: "Super Distributor",
        href: "/UserManagement/SuperDistributor",
        id: 2.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Distributor Master",
        href: "/Distributor/Distributor",
        id: 2.2,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Retailer Master",
        href: "/Retailer/Retailer",
        id: 2.3,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "User Service Status",
        href: "/Admin/UserServiceStatus",
        id: 2.4,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "APP Settings",
        href: "/APPUsers/APPUsersSettings",
        id: 14,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "User KYC Pending",
        href: "/Admin/PendingKycVerification",
        id: 2.5,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },

  {
    title: "Balance Request",
    href: "#",
    id: 3,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-wallet2"></i>,
    collapisble: true,
    children: [
      {
        title: "Balance Request",
        href: "/Admin/ViewBalanceRequestAdmin",
        id: 3.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },

  {
    title: "Commission",
    href: "#",
    id: 4,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-cash-coin"></i>,
    collapisble: true,
    children: [
      {
        title: "Plan",
        href: "/Admin/AllPlans",
        id: 4.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Commission Plan Master",
        href: "/Admin/GetCommissionPlanMaster",
        id: 4.2,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Commission Master Template",
        href: "/Admin/CommissionMasterTemplate",
        id: 4.3,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },
  {
    title: "Credit Debit Details",
    href: "#",
    id: 5,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-credit-card"></i>,
    collapisble: true,
    children: [
      {
        title: "Direct TopUp User",
        href: "/ManageCreditDetails/CreditDebitUsers",
        id: 5.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },
  {
    title: "Manage Bank",
    href: "#",
    id: 6,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-bank"></i>,
    collapisble: true,
    children: [
      {
        title: "Manage Self Bank",
        href: "/Admin/AdminSelfBank",
        id: 6.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },

      {
        title: "Bank Data Manager",
        href: "/Admin/BankDataManager",
        id: 6.3,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Payment Operator",
        href: "/Admin/PaymentOperatorList",
        id: 6.4,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },
  {
    title: "API Config",
    href: "#",
    id: 7,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-link-45deg"></i>,
    collapisble: true,
    children: [
      {
        title: "App Config",
        href: "/Admin/appConfig",
        id: 7.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "API LOGS",
        href: "/Admin/APILogs",
        id: 7.2,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },

      {
        title: "API FORWARD SWITCH",
        href: "/Admin/APIForwardSwitch",
        id: 7.3,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "API REQ/RES BY TxnId",
        href: "/Admin/APIRequestResponseAdmin",
        id: 7.4,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "SMS Logs",
        href: "/Admin/SMSLogs",
        id: 7.5,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Set Charges",
        href: "/Admin/SetCharges",
        id: 7.6,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },
  {
    title: "Management",
    href: "#",
    id: 8,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-gear"></i>,
    collapisble: true,
    children: [
      {
        title: "Systems Setting",
        href: "/Admin/SystemSetting",
        id: 8.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Service Control",
        href: "/Admin/ServicesControl",
        id: 8.2,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Login History",
        href: "/Admin/LoginHistory",
        id: 8.3,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Complaint Manager",
        href: "/Admin/ComplaintManager",
        id: 8.4,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Update CustomerLimit",
        href: "/Admin/CustomerLimitInc",
        id: 8.5,
        suffixColor: "#ef7586",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Update Customer Name",
        href: "/Admin/CustomerNameUpdate",
        id: 8.6,
        suffixColor: "#ef7586",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Change Tpin",
        href: "/Admin/ChangeTpin",
        id: 8.7,
        suffixColor: "#ef7586",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Notification",
        href: "/Admin/Notification",
        id: 8.9,
        suffixColor: "#ef7586",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },
  {
    title: "Reports",
    href: "#",
    id: 9,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-list-columns-reverse"></i>,
    collapisble: true,
    children: [
      {
        title: "Get Live Transaction",
        href: "/Admin/GetLiveTransaction",
        id: 2.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "User Ledger Reports",
        href: "/Admin/AdminLedgeReports",
        id: 9.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },

      {
        title: "ADMIN Ledger Reports",
        href: "/Admin/AdminSelfLedger",
        id: 9.2,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Retailer Transactions by API Reports",
        href: "/Admin/APIWiseRetailersTransactionReport",
        id: 9.2,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      // {
      //   title: "Payout Transaction Reports",
      //   href: "/Admin/PayOutTransactionReports",
      //   id: 9.3,
      //   suffixColor: "#4cb5bb",
      //   icon: <i className="bi bi-chevron-right"></i>,
      //   collapisble: true,
      // },
      {
        title: "Commission Reports",
        href: "/Admin/CommissionReports",
        id: 9.4,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Cashout Transaction",
        href: "/Reports/CashoutTransactionReportsAdmin",
        id: 9.5,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Refund Report",
        href: "/Reports/RefundReportAdmin",
        id: 9.6,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Cashout Direct API",
        href: "/Admin/CashOutReportDirectAPI",
        id: 9.16,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },

      {
        title: "Transaction Reports",
        href: "/Reports/AdminTransactionReport",
        id: 9.7,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "DMT Transaction Search By Account / Sender Mobile",
        href: "/Reports/GetTransactionByAccountNumber",
        id: 9.8,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Transaction search by consumer number",
        href: "/Reports/GetTransactionByConsumerNo",
        id: 9.9,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Bill Payment Reports",
        href: "/Reports/AdminBillPaymentReports",
        id: 9.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "AEPS Transaction Reports",
        href: "/Reports/AEPSTransactionReportsAdmin",
        id: 9.11,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Daily Transaction",
        href: "/Reports/DailyTransactionReports",
        id: 9.12,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "GST Transaction",
        href: "/Reports/GSTTransactionReports",
        id: 9.13,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "TDS Transaction",
        href: "/Reports/TDSTransactionReports",
        id: 9.14,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Change Status By Txn Id",
        href: "/Admin/AdminChangeStatus",
        id: 9.15,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },

  {
    title: "Account Report",
    href: "#",
    id: 10,
    suffixColor: "bg-info text-dark-white",
    icon: <i className="bi bi-person-lines-fill"></i>,
    collapisble: true,
    children: [
      {
        title: "Account Status Report",
        href: "/Reports/AccountStatusReports",
        id: 10.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "ICICI Account Statement Report",
        href: "/Reports/ICICIAccountStatementReport",
        id: 10.1,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Business Report",
        href: "/Admin/AdminBusinessReports",
        id: 10.2,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Business Analysis Report",
        href: "/Admin/AdminBusinessAnalysisReport",
        id: 10.3,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },

      {
        title: "Top Up Report",
        href: "/Reports/AdminTopUpReport",
        id: 10.4,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
      {
        title: "Daily Business Reports",
        href: "/Reports/AdminDailyBusinessReports",
        id: 10.5,
        suffixColor: "#4cb5bb",
        icon: <i className="bi bi-chevron-right"></i>,
        collapisble: true,
      },
    ],
  },
];

export default HorizontalSidebarData;
